import React from 'react';
import PropTypes from 'prop-types';
import HeaderDirectory from './HeaderDirectory';
import RowDirectory from './RowDirectory';
import { StyledTableWrapper } from './style';

const EmployerDirectory = ({ employerDirectory }) => (
  <StyledTableWrapper>
    <HeaderDirectory />
    {employerDirectory.map((item, i) => (
      <RowDirectory key={`row-d-${i + 1}`} dataRow={item} />
    ))}
  </StyledTableWrapper>
);

EmployerDirectory.propTypes = {
  employerDirectory: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      lastname: PropTypes.string,
      alias: PropTypes.string,
      department: PropTypes.string,
      extension: PropTypes.number,
      phones: PropTypes.string,
      email: PropTypes.string
    })
  )
};

export default EmployerDirectory;
